import React from "react"
import Layout from "../components/Layout"
import { graphql, useStaticQuery } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"
import stack from "../constants/tech-stack"
import SEO from "../components/SEO"

const About = () => {
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="About" description="about rafael hernandez" />
      <section className="about-page">
        <div className="section-center about-center">
          <Image fluid={fluid} className="about-img" />
          <article className="about-text">
            <Title title="about me" />
            <p>
              Hello, my name is Rafael Hernandez. I am a first-generation
              college graduate with a Computer Science degree from UC Berkeley.
              I work as a software engineer but love to build things on the
              side, mainly in web design and development.
            </p>
            <div className="about-stack">
              {stack.map(item => {
                return <span key={item.id}>{item.text}</span>
              })}
            </div>
          </article>
        </div>
      </section>
    </Layout>
  )
}

const query = graphql`
  {
    file(relativePath: { eq: "hero-img.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default About
